export const getCsrf = (): string | null => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  if (!meta) {
    return null;
  }
  return meta.getAttribute('content');
};
